import { useTranslation } from 'react-i18next';
import { WEBSITE_ANALYTICS_DAY_OPTIONS } from '../constants';
import type { WebsiteAnalyticsDays } from '../types';

const SELECT_CLASS = 'w-full rounded-md border border-input bg-background px-3 py-2 text-sm';

interface ProductAnalyticsFiltersProps {
  days: WebsiteAnalyticsDays;
  productSlug: string;
  productOptions: string[];
  onDaysChange: (days: WebsiteAnalyticsDays) => void;
  onProductChange: (productSlug: string) => void;
}

export function ProductAnalyticsFilters({
  days,
  productSlug,
  productOptions,
  onDaysChange,
  onProductChange,
}: ProductAnalyticsFiltersProps) {
  const { t } = useTranslation();

  return (
    <div className="rounded-xl border border-border bg-card p-4">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div className="space-y-1.5">
          <label
            htmlFor="website-analytics-product-filter"
            className="text-xs font-medium text-muted-foreground"
          >
            {t('websiteActivity.products.filters.product')}
          </label>
          <select
            id="website-analytics-product-filter"
            value={productSlug}
            onChange={(e) => onProductChange(e.target.value)}
            className={SELECT_CLASS}
          >
            <option value="">{t('websiteActivity.products.filters.allProducts')}</option>
            {productOptions.map((slug) => (
              <option key={slug} value={slug}>
                {slug}
              </option>
            ))}
          </select>
        </div>
        <div className="space-y-1.5">
          <label
            htmlFor="website-analytics-days-filter"
            className="text-xs font-medium text-muted-foreground"
          >
            {t('websiteActivity.products.filters.dateRange')}
          </label>
          <select
            id="website-analytics-days-filter"
            value={String(days)}
            onChange={(e) => onDaysChange(Number(e.target.value) as WebsiteAnalyticsDays)}
            className={SELECT_CLASS}
          >
            {WEBSITE_ANALYTICS_DAY_OPTIONS.map((option) => (
              <option key={option} value={option}>
                {t('websiteActivity.products.filters.days', { count: option })}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}
